import { render, staticRenderFns } from "./ProductLineinvent.vue?vue&type=template&id=0ff1ca66&scoped=true&"
import script from "./ProductLineinvent.vue?vue&type=script&lang=js&"
export * from "./ProductLineinvent.vue?vue&type=script&lang=js&"
import style0 from "./ProductLineinvent.vue?vue&type=style&index=0&id=0ff1ca66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1ca66",
  null
  
)

export default component.exports